'use client';

import { useState } from 'react';
import SplashScreen from '@/components/SplashScreen';
import HomeContent from './home/page';

export default function RootPage() {
  const [entered, setEntered] = useState(false);

  if (entered) {
    return <HomeContent />;
  }

  return <SplashScreen onEnter={() => setEntered(true)} />;
}